<template>
	<div>
		<a-modal :title="getTitle" :width="480" :visible="visible" @cancel="handleCancel">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					取消
				</a-button>
				<a-button key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					保存
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<div>
					<!-- <div>
						<div class="flex center">
							<upload-img v-model="form.icon"></upload-img>
						</div>
						<div class="flex center mt8">
							<div class="ft12 ftw400 cl-notice">菜单图标：建议上传200x200px</div>
						</div>
					</div> -->

					<div class="mt24">
						<a-tree-select v-model="form.pid" style="width: 100%"
							:dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="category"
							placeholder="Please select" >
						</a-tree-select>
					</div>

					<div class="flex  mt24">
						<a-input class="" style="width: 230px;" placeholder="请输入菜单名称" v-model="form.name"
							:maxLength="20">
						</a-input>
						<a-input-number class=" ml20" style="width: 230px;" placeholder="请输入排序号(越小越靠前)"
							v-model="form.sort" :precision="0" :min="0"/>
					</div>
					<div class="flex alcenter mt20">
						<div class="ft14 ftw500 cl-info">菜单类型</div>
						<div style="width: 200px; margin-left: 10px;">
							<a-select style="width: 200px;" v-model="form.type">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in types" :key="index" :value="item.value">{{item.label}}</a-select-option>
							</a-select>
						</div>
					</div>
					<div class="flex  mt10">
						<a-input class="woyaou-input "  prefix="菜单图标" style="width: 480px;" placeholder="请输入菜单图标" v-model="form.icon" :maxLength="50">
						</a-input>
					</div>	
					<div class="flex  mt10">
						<a-input class="woyaou-input "  prefix="权限标识" style="width: 480px;" placeholder="请输入权限标识" v-model="form.perms" :maxLength="50">
						</a-input>
					</div>
					<div class="flex  mt10">
						<a-input class="woyaou-input "  prefix="路径地址" style="width: 480px;" placeholder="请输入路径地址" v-model="form.paths" :maxLength="100">
						</a-input>
					</div>
					<div class="flex  mt10">
						<a-input class="woyaou-input "  prefix="组件地址" style="width: 480px;" placeholder="请输入组件地址" v-model="form.component" :maxLength="100">
						</a-input>
					</div>
					<div class="mt24">
						<div class="flex alcenter">
							<div class="ft14 ftw500 cl-info">是否显示</div>
							<div class="ml16">
								<a-radio-group v-model="form.is_show">
									<a-radio :value="1" >
										是
									</a-radio>
									<a-radio :value="0">
										否
									</a-radio>
								</a-radio-group>
							</div>
						</div>
					</div>
				</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	import uploadImg from '../../../../../components/upload/upload.vue';
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			menu_id: {
				type: Number,
				default: 0,
			},
		},
		components: {
			uploadImg,
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				category: [],
				form: {
					pid: 0,
					icon: '',
					name: '',
					sort: '',
					type: '',
					paths: '',
					component: '',
					perms: '',
					is_show: 1
				},
				types: [
					{
						value: 'M',
						label: '目录'
					},
					{
						value: 'C',
						label: '菜单'
					},
					{
						value: 'A',
						label: '按钮'
					}
				]
	
			}
		},
		computed: {
			getTitle() {
				if (this.menu_id == 0) {
					return "添加菜单";
				} else {
					return "编辑菜单"
				}
			}
		},
		created() {
			this.loaddata();
		},
		methods: {
			
			loaddata(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showSysmenu',{
					menu_id:this.menu_id,
				}).then(res=>{
					this.category=res.category;
					console.log('this.category.tree',res.category)
					if(res.detail){
						this.form=res.detail;
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},

			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},

			/**
			 * 提交数据
			 */
			onSubmit() {
				// 表单验证
				if (!this.form.name) {
					this.$message.warning('请输入菜单名称');
					return;
				}
				
				if (!this.form.type) {
					this.$message.warning('请选择菜单类型');
					return;
				}
				
				// 新增：权限标识验证
				if (!this.form.perms || this.form.perms.trim() === '') {
					this.$message.warning('请输入权限标识');
					return;
				}

				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/saveSysmenu',{
					menu_id:this.menu_id,
					name:this.form.name,
					pid:this.form.pid,
					icon:this.form.icon,
					sort:this.form.sort,
					type:this.form.type,
					paths:this.form.paths,
					component:this.form.component,
					perms:this.form.perms,
					is_show:this.form.is_show
				}).then(res=>{
					this.$message.success('保存成功',1,()=>{
						this.confirmLoading=false;
						this.$emit("ok");
					})
					
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
				
			},

		}
	}
</script>

<style>
	
</style>
